import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/free-solid-svg-icons/faBell";
import { faListCheck } from "@fortawesome/free-solid-svg-icons/faListCheck";

import { KanbanColumnAutomationActionType } from "../../model/kanban/types/KanbanColumnAutomationActionType.enum";

export const kanbanAutomationActionMeta: Record<
  KanbanColumnAutomationActionType,
  { icon: IconDefinition; titleKey: string; descriptionKey: string }
> = {
  [KanbanColumnAutomationActionType.NOTIFICATION]: {
    icon: faBell,
    titleKey: "kanban.automation.actionType.notification.title",
    descriptionKey: "kanban.automation.actionType.notification.description",
  },
  [KanbanColumnAutomationActionType.CREATE_TASK]: {
    icon: faListCheck,
    titleKey: "kanban.automation.actionType.createTask.title",
    descriptionKey: "kanban.automation.actionType.createTask.description",
  },
};
